import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MainLayout from '../layout/main-layout';
import { isPageBlocked } from '../utils/gestion-access';

const PrivateRoute = ({ redirectTo = "/auth/login", children  }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const { pathname } = useLocation();
  
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} />
   }
   if (isPageBlocked(user, pathname)) {
    return (
      <MainLayout>
        <div className="mx-auto max-w-lg py-10 text-center">
          <h1 className="mb-2 text-lg font-bold">Pas de permission</h1>
          <p className="text-sm text-gray-600">
            Vous n&apos;avez pas accès à cette page. Le menu reste disponible pour ouvrir une page autorisée.
          </p>
        </div>
      </MainLayout>
    );
   }
   return children ? children : <Outlet />
};

export default PrivateRoute;